import RichTextInput from 'ra-input-rich-text';

// This component wraps react-admin's RichTextInput.
// Errors are expected for now, this is the designated place to implement the necessary fixes.
const CustomRichTextInput = (props) => {
    const { source, label, variant = 'outlined', ...rest } = props;

    return (
        <RichTextInput
            source={source}
            label={label}
            variant={variant}
            {...rest}
        />
    );
};

export default CustomRichTextInput;
